<template>
  <div class="support-ticket-container">
    <header class="support-ticket-header">
      <div class="d-flex w-100 align-items-center justify-content-between">
        <div>
          <img src="@/assets/img/logos/logo-dark.png" width="85" />
        </div>
        <router-link class="btn-outline-blue" to="/mobile-support-ticketing">Support Ticket List</router-link>
      </div>
    </header>

    <div class="section-title text-center mb-4">{{ $t('add') }} {{ $t('supportticketing') }}</div>

    <div class="row">
      <div class="col-12 mb-4">
        <label class="small text-muted">Ticket raised by:</label>
        <input type="text" disabled class="form-control" :value="selecteduser" />
      </div>
      <div class="col-12 mb-4">
        <label class="small text-muted">Add a subject to ticket</label>
        <input type="text" class="form-control"  v-model="ticket_subject" placeholder="Subject" />
      </div>

      <div class="col-12 mb-4">
        <label class="small text-muted">Select cinema for support ticket.</label>
        <b-form-select v-model="selectedcinema" :options="cinemaOption"></b-form-select>
        {{selectedcinema}}
      </div>

      <div class="col-12 mb-4">
        <label class="small text-muted">Select category for support ticket.</label>
        <b-form-select v-model="category_id" :options="categoryOption"></b-form-select>
      </div>

      <!-- <div class="col-12 mb-4">
        <label class="small text-muted">Upload photo (Optional)</label>

        <label for="supportFileUpload" class="form-control"> -->
          <!-- ONCE THE FILE IS SELECTED REPLACE THE FILE NAME HERE -->
          <!-- <small>No File Selected</small>
        </label>
        <input type="file" id="supportFileUpload" class="d-none" />
      </div> -->

      <div class="col-12 mb-4">
        <label class="small text-muted">Add a detailed description to ticket</label>
        <textarea class="form-control" v-model="ticket_description" placeholder="Description" rows="7"></textarea>
      </div>
       <div v-for="(item, index) in Url" :key="index" class="row">
        <div class="col-3 mb-4 pr-0">
          <label class="material-file-upload">
            <!-- v-on:change="onFileUpload($event,PosterItem,PosterIndex,MovieContentIndex)" -->
            <input
              type="file"
              v-on:change="setImage($event, index)"
              name="image"
              :id="'image'+index"
            />
            <div
              class="label"
              v-bind:class="{ 'shift-up': item.selected_url  && item.selected_url.length > 0  }"
            >
              <div class="text-truncate">Upload Image</div>
            </div>
            <div class="uploaded-file-name">
              <div class="text-truncate pt-2">{{ item.selected_url }}</div>
            </div>
          </label>
        </div>
        <p class="error_message">
          <span></span>
        </p>
        <div class="col-1 mb-4">
          <img
            v-if="item.selected_url && item.selected_url.length > 0"
            :src="_GetImagePath(item.selected_url)"
            @click="openImageModal( 'Upload Image', item.selected_url)"
            height="38"
            width="38"
            class="rounded c-pointer"
          />
          <img
            v-else
            src="@/assets/img/icons/empty-image.svg"
            height="35"
            width="35"
            class="rounded"
          />
        </div>
        <div class="col-3 mb-4 pl-1">
          <button v-if="index == 0" @click.prevent.stop="addSupportImage()" class="btn-transparent">
            <img src="@/assets/img/icons/plus.svg" height="35" width="35" />
          </button>
          <button v-else @click.prevent.stop="removeSupportImage(index)" class="btn-transparent">
            <img src="@/assets/img/icons/minus.svg" height="35" width="35" />
          </button>
        </div>
      </div>

      <div class="col-12 mb-3">
        <div class="d-flex w-100 align-items-center justify-content-between">
          <button @click="route" class="btn btn-sm btn-outline-danger text-danger">Cancel</button>

          <button
            class="btn btn-sm btn-outline-blue"
            @click.prevent.stop="onResetForm"
          >{{ $t('reset') }} Feilds</button>

          <button @click.prevent.stop="OnFinalSubmit(false)" class="btn btn-sm btn-outline-blue">Add More</button>
        </div>
      </div>

      <div class="col-12 mb-5">
        <button
          class="btn-submit-support-ticket"
          @click.prevent.stop="OnFinalSubmit(true)"
        >Submit Ticket</button>
      </div>
        <!-- Thumbnail IMAGE Crop MODAL -->
    <b-modal id="imagecropper" hide-header hide-footer no-close-on-backdrop>
      <button class="btn-clearDate text-right" v-on:click="hideCropperModal('imagecropper')">✖</button>

      <label class="h4 mt-2 mb-4 text-center">Crop Image</label>
      <vue-cropper
        ref="cropper"
        :src="imgSrc"
        :viewMode="1"
        :cropBoxResizable="true"
        dragMode="none"
        alt="Source Image"
        preview=".preview"
      ></vue-cropper>
      <br />
      <button class="btn-blue" @click.prevent.stop="cropImage">Save</button>
    </b-modal>

    <b-modal
      ref="preview-modal"
      id="selected-image-preview-modal"
      size="lg"
      hide-header
      hide-footer
    >
      <label class="h4 mt-2 mb-4 text-center">{{ tempModalImageName }}</label>
      <button class="btn-modal-close" @click="$bvModal.hide('selected-image-preview-modal')">&times;</button>
      <img :src="_GetImagePath(tempModalImagePath)" class="img-fluid" />
    </b-modal>
    </div>

    <!-- <div class="white-wrapper">
      <div class="row">
        <div class="col-lg-6 col-xl-4 mb-4">
          <div class="d-flex align-items-center">
            <div class="dropdown-curve-container">
              <label
                :class="selectedcinema && selectedcinema.length > 0 ? 'shift-up' : '' "
              >Select Cinema</label>
              <b-dropdown
                :disabled="isRoleID"
                :text="selectedcinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  href="#"
                  v-for="(Cinema, CinemaIndex) in Cinemas"
                  :key="CinemaIndex"
                  v-on:click="OnSelect('cinema', $event, Cinema)"
                >{{ Cinema.cine_name }}</b-dropdown-item>
              </b-dropdown>
            </div>

            <Tooltip :title="$t('supportticket_cinema')" />
          </div>
          <p class="error_message">
            <span v-if="submitted && selectedcinema.length == 0">Please Select Cinema.</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="dropdown-curve-container">
              <label
                :class="selectedcategory && selectedcategory.length > 0 ? 'shift-up' : '' "
              >{{ $t('select') }} {{ $tc('category', 1) }}</label>
              <b-dropdown :text="selectedcategory" variant="dropdown-curve" class="w-100">
                <b-dropdown-item
                  href="#"
                  v-for="(category, categoryIndex) in TicketCategoryList"
                  :key="categoryIndex"
                  v-on:click="OnSelect('category', $event, category)"
                >{{ category.stc_name }}</b-dropdown-item>
              </b-dropdown>
            </div>

            <Tooltip :title="$t('supportticket_category')" />
          </div>
          <p class="error_message">
            <span v-if="submitted && selectedcategory.length == 0">Please Select Category.</span>
          </p>
        </div>

        <div class="col-lg-12 align-self-center mb-4">
          <div class="input-material">
            <input
              v-model="ticket_subject"
              v-validate="'required'"
              placeholder="."
              type="text"
              name="subject"
              id="subject"
            />
            <label>{{ $t('subject') }}</label>
          </div>
          <p v-if="submitted && errors.has('subject')" class="error_message">
            <span>{{ errors.first("subject")}}</span>
          </p>
        </div>

        <div class="col-lg-12 col-xl-12 mb-4">
          <div class="d-flex">
            <div class="input-material-textarea">
              <textarea
                v-model="ticket_description"
                rows="5"
                v-validate="'required'"
                type="text"
                placeholder="Description"
                name="description"
                id="description"
                class="rounded-10"
              ></textarea>
            </div>
          </div>
          <p v-if="submitted && errors.has('description')" class="error_message">
            <span>{{ errors.first("description")}}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <label class="mb-0 mr-3">{{ $t('active') }}</label>
            <b-form-checkbox v-model="st_is_active" name="check-button" switch></b-form-checkbox>
          </div>
        </div>

        <div class="col-md-12 text-center">
          <button
            :disabled="btenable"
          
            class="btn-blue"
          >{{ $t('save') }}</button>
          <button
            :disabled="btenable"
            @click.prevent.stop="OnFinalSubmit(false)"
            class="btn-blue"
          >{{ $t('saveaddmore') }}</button>
         
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="/mobile-support-ticketing"
          >{{ $t('cancel') }}</b-button>
        </div>
      </div>
    </div>-->
  </div>
</template>


<script>
import "@/assets/css/supportTicket.css";
import CinemasService from "@/services/CinemasService";
import MasterService from "@/services/MasterService";
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";

export default {
  components: { VueCropper },
  data() {
    return {
      selected: null,
      options: [
        { value: null, text: "Please select a cinema" },
        { value: "a", text: "This is First option" },
        { value: "b", text: "Selected Option" },
        { value: { C: "3PO" }, text: "This is an option with object value" },
        { value: "d", text: "This one is disabled", disabled: true }
      ],
      cinemaOption: [{ value: null, text: "Please select a cinema" }],

      btenable: false,
      isRoleID: true,
      submitted: false,
      isUserID: true,
      Cinemas: [],

      cine_id: null,
      selectedcinema: null,
      user_id: null,
      selecteduser: "",
      category_id: null,
      categoryOption: [{ value: null, text: "Please select a category" }],
      selectedcategory: "",
      ticket_subject: "",
      ticket_description: "",
      st_is_active: true,
      TicketCategoryList: [],
      Users: [],
       Url: [
        {
          selected_url: ""
        }
      ],
      tempModalImageName: null,
      tempModalImagePath: null,
      imgSrc: "",
      file: "",
      filename: "",
      indexofthubmnail: ""
    };
  },
  beforeMount() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    let roleid = this.secureStore.get("USINFO").role_id;
    this.user_id = this.secureStore.get("USINFO").user_id;
    this.selecteduser =
      this.secureStore.get("USINFO").first_name +
        " " +
        this.secureStore.get("USINFO").middle_name &&
      this.secureStore.get("USINFO").middle_name != null
        ? this.secureStore.get("USINFO").middle_name
        : this.secureStore.get("USINFO").first_name +
          " " +
          this.secureStore.get("USINFO").last_name;

    if (true) {
      this.isRoleID = false;
    }

    if (this.user_id == 1) {
      this.isUserID = false;
    }
    this.getCinemasList(obj);
    this.GetSupportTicketCategory();
    // this.getUsersList(obj, this.user_id);
  },
  methods: {
     addSupportImage: function() {
      this.Url.push({
        selected_url: ""
      });
    },
    removeSupportImage: function(index) {
      this.Url.splice(index, 1);
    },
    hideCropperModal: function(modal) {
      this.$bvModal.hide("imagecropper");
    },
    openImageModal: function(image_name, image_path) {
      this.tempModalImagePath = image_path;
      this.tempModalImageName = image_name;
      this.$refs["preview-modal"].show();
    },
    setImage: function(e, index) {
      this.file = e.target.files[0];
      this.filename = e.target.files[0]["name"];
      this.indexofthubmnail = index;

      if (this.file.type.indexOf("image/") === -1) {
        this.$toasted.show("Please select an image file");
        return;
      }
      if (typeof FileReader === "function") {
        const reader = new FileReader();
        reader.onload = event => {
          this.imgSrc = event.target.result;
          this.width = 300;
          this.height = 300;
          this.$bvModal.show("imagecropper");
          e.target.value = "";
        };
        reader.readAsDataURL(this.file);
      } else {
      }
    },
    cropImage() {
      // get image data for post processing, e.g. upload or setting image src
      this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
      // this.data = JSON.stringify(this.$refs.cropper.getData(), null, 4);
      var block = this.cropImg.split(";");
      // Get the content type of the image
      var contentType = block[0].split(":")[1]; // In this case "image/gif"
      // get the real base64 content of the file
      var realData = block[1].split(",")[1]; // In this case "R0lGODlhPQBEAPeoAJosM...."
      // Convert it to a blob to upload
      var blob1 = this.b64toBlob(realData, contentType);
      this.uploadImage(blob1, this.filename, this.indexofthubmnail);
    },
    b64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || "";
      sliceSize = sliceSize || 512;

      var byteCharacters = atob(b64Data);
      var byteArrays = [];

      for (
        var offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);

        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        var byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }

      var blob = new Blob(byteArrays, { type: contentType });
      return blob;
    },
    uploadImage: function(image, filename, index) {
      let loader = this.$loading.show();

      let self = this;
      let formData = new FormData();
      formData.append("image", image, filename);
      formData.append("imagePath", "Support Ticket Image");
      MasterService.GlobalUploadImage(formData)
        .then(response => {
          const { data } = response;
          data.message ? this.$toasted.show(data.message) : "";
          if (data.status) {
            self.Url[index].selected_url = data.path;
            this.$bvModal.hide("imagecropper");
          }
          self.BaseURL = data.BaseURL;
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => loader.hide(), 1000);
        });
    },
    route(){
       this.$router.push({
        path: '/mobile-support-ticketing',
      });
    },
    getCinemasList: function(cine_id) {
      this.Cinemas = [];
      let payload = {
        tableName: "ms_cinemas",
        cine_is_active: "Y"
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.Cinemas.map(x=>{
              this.cinemaOption.push({value: x.cine_id, text: x.cine_name})
            })
            console.log('this.cinemaOption :>> ', this.cinemaOption);
            this.Cinemas.map(x => {
              if (String(cine_id) === String(x.cine_id)) {
                this.selectedcinema = x.cine_name;
                this.cine_id = x.cine_id;
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },

    // getUsersList: function(cinema_id, user_id) {
    //   let body = this.getRequestBody("GET", undefined, {
    //     GET: "/admin/",
    //     tableName: "users"
    //   });
    //   if (cinema_id) {
    //     body[cinema_id] = cinema_id;
    //   }
    //   MasterService.GlobalRequest(body)
    //     .then(response => {
    //       const { data } = response;
    //       if (data.status && data.Records.length > 0) {
    //         this.Users = data.Records;

    //         this.Users.map(x => {
    //           if (String(user_id) === String(x.user_id)) {
    //             this.selecteduser =
    //               x.first_name + " " + x.middle_name + " " + x.last_name;
    //             this.user_id = x.user_id;
    //           }
    //         });
    //       } else {
    //       }
    //     })
    //     .catch(this._CatchError);
    // },

    GetSupportTicketCategory: function() {
      let payload = {
        limit: null,
        currentPage: null
      };

      MasterService.GetCategory(payload)
        .then(response => {
          const { data } = response;

          if (data.status) {
            if (data.Records && data.Records.length > 0) {
              this.TicketCategoryList = data.Records;
               this.TicketCategoryList.map(x=>{
              this.categoryOption.push({value: x.stc_id, text: x.stc_name})
            })

              if (data.totalRows >= 10) {
                this.rows = data.totalRows;
              } else {
                this.rows = data.totalRows;
                this.selectedvalue = data.totalRows;
              }
            } else {
              this.$toasted.show(data.message);
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },

    OnSelect: function(type, event, data) {
      if (type == "cinema") {
        this.selectedcinema = data.cine_name;
        this.cine_id = data.cine_id;
      }
      // if (type == "user") {
      //   this.selecteduser =
      //     data.first_name + " " + data.middle_name + " " + data.last_name;
      //   this.user_id = data.user_id;
      // }
      if (type == "category") {
        this.selectedcategory = data.stc_name;
        this.category_id = data.stc_id;
      }
    },

    onResetForm: function() {
       this.category_id = null;
      this.ticket_subject = "";
      this.ticket_description = "";
      this.selectedcategory = null;
      this.cine_id = null;
      this.selectedcinema = null;
      this.Url= [
        {
          selected_url: ""
        }
      ]
      

      // this.user_id = null;
      // this.selecteduser = null;
    },

    OnFinalSubmit: function(flag) {
      this.submitted = true;

      if (this.selectedcinema && this.selectedcinema.length == 0) {
        return;
      }
      if (this.selecteduser == null || this.selecteduser.length == 0) {
        return;
      }
      if (this.category_id && this.category_id.length == 0) {
        return;
      } else {
        this.$validator.validate().then(valid => {
          if (valid) {
            this.btenable = true;
            let payload = {
              cinema_id: this.selectedcinema,
              user_id: this.user_id,
              subject: this.ticket_subject,
              description: this.ticket_description,
              category_id: this.category_id,
              ImageUrls: this.Url,
              is_active: this.st_is_active
            };

            CinemasService.AddSupportTicket(payload)
              .then(response => {
                const { data } = response;

                if (data.status) {
                  this.onResetForm();
                  this.$toasted.show(data.message);

                  if (flag) {
                    this.$router.push({
                      path: "/mobile-support-ticketing"
                    });
                  } else {
                    this.submitted = false;
                  }
                } else {
                  this.btenable = false;
                  this.$toasted.show(data.message);
                }
              })
              .catch(this._CatchError);
          }
        });
      }
    }
  }
};
</script>
 


// WEBPACK FOOTER //
// src/components/Pages/mobileSupportTicketComponent/addMobileSupportTicketing.vue